module.exports = __webpack_public_path__ + "img/icon-ai-report.1de34914.svg";